export default __webpack_public_path__ + "static/media/view-in-progress.5ffb0311.svg";